import { getDefaultColorTheme } from "./color-themes/default-color-theme";
import { getLightColorTheme } from "./color-themes/light-theme";

export const themes = {
	"1": getDefaultColorTheme,
	"2": getLightColorTheme
};

export type ColorThemeId = keyof typeof themes;